﻿import { UTL } from "../util/classes";
import { MyGeneralTimer } from "./MyGeneralTimer";

export class NotifyPlusStyleRecord {
    public font_size: string = "20px";
    public overlay_BackgroundColor: string = "rgba(0, 0, 0, 0.5)";
    public back_color: string = "#2c3e50"; // צבע הכפתור
    public fore_color: string = "white";      // צבע הטקסט
    public direction: string = "ltr";
    public display_progress_milliseconds: boolean = false;

    // הגדרות רוחב
    public use_fixed_width: boolean = /*true*/false;
    public fixed_width_in_pixels: string = "220px";

    // חישובים גיאומטריים יחסיים
    public calculate_button_padding(): string {
        let size = parseFloat(this.font_size);
        // אם הרוחב קבוע, נתמקד ב-padding אנכי. אם דינמי, נוסיף padding אופקי נדיב.
        let vertical = size * 0.8;
        let horizontal = this.use_fixed_width ? 0 : size * 2;
        return `${vertical}px ${horizontal}px`;
    }

    public calculate_button_border_radius(): string {
        // יוצר צורת גלולה מושלמת לפי גודל הגופן
        return `${parseFloat(this.font_size) * 2}px`;
    }
}

export class NotifyPlusAuxFunctions {

    public static apply_style_to_overlay_element(overlay_element: HTMLDivElement, style_rec: NotifyPlusStyleRecord): void {
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0px";
        overlay_element.style.left = "0px";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = style_rec.overlay_BackgroundColor;
        overlay_element.style.zIndex = "9999";
    }

    public static apply_style_to_popup_element(popup_element: HTMLDivElement, style_rec: NotifyPlusStyleRecord): void {
        popup_element.style.direction = style_rec.direction;
        popup_element.style.position = "absolute";
        popup_element.style.padding = "0px";

        // גיאומטריה: ה-Popup מתכווץ בדיוק לגודל הכפתור שבתוכו
        popup_element.style.width = "auto";
        popup_element.style.height = "auto";

        popup_element.style.backgroundColor = "transparent";  // gemeni זה של 
        popup_element.style.border = "none";
        popup_element.style.overflow = "visible"; // מאפשר לצל של הכפתור להיראות
    }

    public static apply_style_to_text_element(text_element: HTMLDivElement, style_rec: NotifyPlusStyleRecord): void {
        text_element.style.direction = style_rec.direction;
        text_element.style.fontSize = style_rec.font_size;
        text_element.style.fontFamily = "system-ui, -apple-system, sans-serif";
        text_element.style.color = style_rec.fore_color;
        text_element.style.backgroundColor = style_rec.back_color;

        // גיאומטריית הכפתור
        text_element.style.display = "inline-block";
        text_element.style.textAlign = "center";
        text_element.style.padding = style_rec.calculate_button_padding();
        text_element.style.borderRadius = style_rec.calculate_button_border_radius();

        // החלת לוגיקת הרוחב
        if (style_rec.use_fixed_width == true) {
            text_element.style.width = style_rec.fixed_width_in_pixels;
        }
        else {
            text_element.style.width = "auto";
            text_element.style.minWidth = "120px";
        }

        // טיפול בטקסט ארוך
        text_element.style.whiteSpace = "nowrap";
        text_element.style.overflow = "hidden";
        text_element.style.textOverflow = "ellipsis";

        // עיצוב משלים
        text_element.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.3)";
        text_element.style.userSelect = "none";
        text_element.style.pointerEvents = "none";
        text_element.style.fontWeight = "500";
    }

    public static create_rec_style_v1(p_direction: string = "ltr", p_base_fontSize: string = "30px", p_backcolor: string = "red", p_forecolor: string = "black", p_progress_in_miliseconds: boolean = false, p_debug: boolean = false): NotifyPlusStyleRecord {
        //alert(`p_direction=${p_direction}`);
        //debugger;
        if (typeof p_direction !== "string") {
            alert("Error: p_direction must be a string");
            return;
        }
        if (typeof p_base_fontSize !== "string") {
            alert("Error: p_direction must be a string");
            return;
        }
        const var_style_rec: NotifyPlusStyleRecord = new NotifyPlusStyleRecord();
        //alert(`p_direction=${p_direction}`);
        //debugger;
        var_style_rec.direction = p_direction;
        var_style_rec.display_progress_milliseconds = p_progress_in_miliseconds;
        var_style_rec.font_size = p_base_fontSize;
        var_style_rec.back_color = p_backcolor;
        var_style_rec.fore_color = p_forecolor;
        return var_style_rec;
    }

}
export class NotifyPlus {
    private static IS_INITIALZED: boolean = false;
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה
    private static IS_OPENED: boolean = false;
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה
    private static overlay_element: HTMLDivElement = null;
    private static popup_element: HTMLDivElement = null;
    private static text_element: HTMLDivElement = null;

    public static par_text_str: string = "";
    public static par_style_rec: NotifyPlusStyleRecord = null;

    private static overlay_keydown(event: KeyboardEvent): void {
        if (/*NotifyPlusAuxFunctions.keydown_event_should_preventDefault(event) == */true) {
            event.preventDefault(); // לשים את הפקודה הזאת gemini :הערה
            event.stopPropagation(); // לשים את הפקודה הזאת gemini :הערה
        }
    }

    static overlay_mousedown(event: MouseEvent) {
        //---------------------------------------------------------------------------------------------
        //                               ."event.preventDefault();" שים לב. אנחנו מפעילים באירוע הזה את
        // למה? בגלל שאם לא מבצעים זאת אז לחיצה על העכבר במקום כלשהו גורמת לפוקוס לעבור למקום אחר כלשהו
        //---------------------------------------------------------------------------------------------
        event.preventDefault(); // הלך לאיבוד focus ללא השורה הזאת ה
    }




    private static perform_INITIALZE_INA() {
        const freezed_IS_INITIALZED: boolean = NotifyPlus.IS_INITIALZED;
        if (freezed_IS_INITIALZED == false) {
            NotifyPlus.overlay_element = document.createElement("div");;
            NotifyPlus.popup_element = document.createElement("div");;
            NotifyPlus.text_element = document.createElement("div");;
            //-----------------------------
            NotifyPlus.overlay_element.appendChild(NotifyPlus.popup_element);
            NotifyPlus.popup_element.appendChild(NotifyPlus.text_element);
            //-----------------------------
            NotifyPlus.overlay_element.addEventListener("keydown", NotifyPlus.overlay_keydown);
            NotifyPlus.overlay_element.addEventListener("mousedown", NotifyPlus.overlay_mousedown);
            //-----------------------------

            NotifyPlus.IS_INITIALZED = true;
        }
    }



    public static prepare(): void {
        NotifyPlus.perform_INITIALZE_INA();

        if (true) {

            NotifyPlusAuxFunctions.apply_style_to_overlay_element(NotifyPlus.overlay_element, NotifyPlus.par_style_rec);
            NotifyPlusAuxFunctions.apply_style_to_popup_element(NotifyPlus.popup_element, NotifyPlus.par_style_rec);
            NotifyPlusAuxFunctions.apply_style_to_text_element(NotifyPlus.text_element, NotifyPlus.par_style_rec);
        }

        if (true) {
            NotifyPlus.text_element.innerText = NotifyPlus.par_text_str;
            //NotifyPlus.text_element.style.fontSize = NotifyPlus.par_style_rec.text_element_fontSize;
        }

    }

    public static Open(p_text_str: string, p_style_rec: NotifyPlusStyleRecord = null): void {
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה


        // Async אינו Notify שים לב ש
        // Async אינו Notify שים לב ש
        // Async אינו Notify שים לב ש
        // Async אינו Notify שים לב ש

        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה
        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה

        const freezed_IS_OPENED = NotifyPlus.IS_OPENED;


        if (p_style_rec != null && (p_style_rec instanceof NotifyPlusStyleRecord) == false) {
            alert("NotifyPlus.p_style_rec is not NotifyPlusStyleRecord");
            return;
        }


        // באופן תקין גם אם האובייקט כבר פתוח Open שים לב שהחל מתאריך 1.5.2026 אנחנו מאפשרים לבצע
        // באופן תקין גם אם האובייקט כבר פתוח Open שים לב שהחל מתאריך 1.5.2026 אנחנו מאפשרים לבצע
        // באופן תקין גם אם האובייקט כבר פתוח Open שים לב שהחל מתאריך 1.5.2026 אנחנו מאפשרים לבצע
        /*
        if (NotifyPlus.overlay_element !== null && NotifyPlus.overlay_element !== undefined && NotifyPlus.overlay_element.parentNode !== null) {
            alert("NotifyPlus.Open().Error: NotifyPlus is already open.");
            return;
        }
        */

        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        NotifyPlus.par_text_str = p_text_str;
        NotifyPlus.par_style_rec = p_style_rec;
        if (NotifyPlus.par_style_rec == null) {

            NotifyPlus.par_style_rec = NotifyPlusAuxFunctions.create_rec_style_v1("ltr", "20px", "green", "black", false);
        }
        


        NotifyPlus.prepare();
        if (freezed_IS_OPENED == false) {
            document.body.appendChild(NotifyPlus.overlay_element);
            UTL.center_popup_element_inside_overlay_element(NotifyPlus.popup_element, NotifyPlus.overlay_element);
        }
        NotifyPlus.startTime = Date.now();
        if (p_style_rec.display_progress_milliseconds == true) {
            MyGeneralTimer.Start(NotifyPlus.RespondToTimer);
        }
        if (p_style_rec.display_progress_milliseconds == false) {
            MyGeneralTimer.Stop();
        }
        NotifyPlus.IS_OPENED = true;
    }

    public static Close(): void {
        // בשלב זה אנחנו לא רוצים הערות שם שגוי
        // בשלב זה אנחנו לא רוצים הערות שם שגוי


        if (NotifyPlus.overlay_element === null || NotifyPlus.overlay_element === undefined) {
            /*alert("NotifyPlus.Close().Error: overlay_element is null or undefined.");*/
            return;
        }

        if (NotifyPlus.overlay_element.parentNode === null) {
            /*alert("NotifyPlus.Close(). error may be you didnt open or did multiple close");*/
            return;
        }

        if (NotifyPlus.overlay_element.parentNode !== document.body) {
            /*alert("NotifyPlus.Close().Error: overlay_element is not a child of document.body.");*/
            return;
        }


        document.body.removeChild(NotifyPlus.overlay_element);
        MyGeneralTimer.Stop();
        NotifyPlus.IS_OPENED = false;
    }

    public static startTime: number = Date.now();

    public static RespondToTimer() {
        if (NotifyPlus.IS_OPENED == true) {
            console.log("NotifyPlus.RespondToTimer()");
            const now = Date.now();
            const elapsedMs = now - NotifyPlus.startTime;
            const tenths = Math.floor((elapsedMs % 1000) / 100);
            const seconds = Math.floor(elapsedMs / 1000);
            NotifyPlus.text_element.innerText = NotifyPlus.par_text_str + " " + `${seconds}.${tenths}`;
        }
    }
}
